module.exports = __webpack_public_path__ + "img/icon-close.3bbe74fb.svg";